import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Catalogo from "./pages/Catalogo";
import Contato from "./pages/Contato";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { auth } from "./firebase"; // Importando autenticação do Firebase
import { onAuthStateChanged } from "firebase/auth";

export default function App() {
  const [user, setUser] = useState(null);

  // 🔥 Verifica se o usuário está autenticado
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (loggedUser) => {
      setUser(loggedUser); // Se estiver logado, salva o usuário
    });
    return () => unsubscribe(); // Cleanup na desmontagem
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        
        {/* Navbar fixa no topo */}
        <Navbar />

        {/* Rotas do Aplicativo */}
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/login" element={<Login />} />

            {/* 🔐 Rota protegida para Admin */}
            <Route
              path="/admin"
              element={user ? <Admin /> : <Navigate to="/login" />}
            />

            {/* Caso o usuário tente acessar uma rota inexistente */}
            <Route path="*" element={<Home />} />
          </Routes>
        </div>

        {/* Footer fixo na parte inferior */}
        <Footer />
      </div>
    </Router>
  );
}
